import { Trans } from 'react-i18next';
import CustomModal from '../../../../../components/Modal/CustomModal';
import SettingsApp from '../Functionality/SettingsApp';
import AttendanceColor from './AttendanceColor';
import FoodieSetting from './FoodieSetting';
import ManageButtonsHeader from './ManageButtonsHeader';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param {Function} props.handleBtnDinning - Callback to switch to dining view.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 * @returns {JSX.Element}
 */
const Settings = ({
    subView,
    handleBtnDinning,
    handleBtnSettings,
    handleBtnDepartmentPolicies,
    handleBtnTotalMeals,
    color,
    setColor
}) => {
    const {
        handleChange,
        item,
        onChange,
        emptyFields,
        pricePlaceholder,
        isValidSelectionMenuDelay,
        isValidRecordTimeout,
        recordTimeoutRangeText,
        isValidCost,
        isValidCostText,
        isValidSubsidy,
        isValidSubsidyText,
        isValidExtraMealSubsidy,
        isValidExtraMealSubsidyText,
        showModal,
        setShowModal,
        handleConfirmBaseCost,
        t,
        onCostChange
    } = SettingsApp({
        color,
        setColor
    });


    return (
        <>
            <div className='row px-0 '>
                <div className='d-flex gap-3 px-0'>
                    <ManageButtonsHeader
                        subView={subView}
                        handleBtnDinning={handleBtnDinning}
                        handleBtnSettings={handleBtnSettings}
                        handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                        handleBtnTotalMeals={handleBtnTotalMeals}
                    />
                </div>
                <AttendanceColor item={color} onChange={handleChange} />
                <FoodieSetting
                    item={item}
                    onChange={onChange}
                    emptyFields={emptyFields}
                    pricePlaceholder={pricePlaceholder}
                    isValidSelectionMenuDelay={isValidSelectionMenuDelay}
                    isValidRecordTimeout={isValidRecordTimeout}
                    recordTimeoutRangeText={recordTimeoutRangeText}
                    isValidCost={isValidCost}
                    isValidCostText={isValidCostText}
                    isValidSubsidy={isValidSubsidy}
                    isValidSubsidyText={isValidSubsidyText}
                    isValidExtraMealSubsidy={isValidExtraMealSubsidy}
                    isValidExtraMealSubsidyText={isValidExtraMealSubsidyText}
                    onCostChange={onCostChange}
                />
            </div>
            <CustomModal
                title={t('apply_meal_pricing')}
                size='md'
                buttonConfirm='confirm'
                show={showModal}
                onHide={() => setShowModal(false)}
                cancelButton={true}
                confirmButton={true}
                onConfirm={handleConfirmBaseCost}
            >
                <div className={'row'}>
                    <div className={'col-12'}>
                        <div className={'row d-flex align-items-center'}>
                            <p className='font-color-text-950 ibl-font-w-400 ibl-ientry-p my-3 text-center'>
                                {t('apply_meal_pricing_warning')}
                            </p>

                            <p className='font-color-text-950 ibl-font-w-400 ibl-ientry-p text-center my-3'>
                                <Trans
                                    i18nKey='apply_meal_pricing_warning_note'
                                    components={{
                                        strong: <span className='ibl-font-w-700' />,
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default Settings;
